import { RowSelectionState } from '@tanstack/react-table';

/**
 * Convert array of selected IDs to RowSelectionState
 */
export function idsToRowSelection(selectedIds: string[]): RowSelectionState {
  const selection: RowSelectionState = {};
  selectedIds.forEach((id) => {
    selection[id] = true;
  });
  return selection;
}

/**
 * Convert RowSelectionState to array of selected IDs
 */
export function rowSelectionToIds(rowSelection: RowSelectionState): string[] {
  return Object.keys(rowSelection).filter((id) => rowSelection[id]);
}

/**
 * Check if selection is controlled (has onSelectionChange callback)
 */
export function isControlledSelection(onSelectionChange?: (selectedIds: string[]) => void): boolean {
  return !!onSelectionChange;
}
